<script lang="ts" setup>
const props = defineProps<{
  invoiceNumber: string;
}>();
</script>

<template>
  <span class="text-primary font-weight-500" data-qa="invoice-link">{{ props.invoiceNumber }}</span>
</template>
